import {
  Tab,
  Flex,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
} from "@chakra-ui/react";

import ProductDescription from "../products/productDescription";
import ProductAdditionalInfo from "../products/productAdditionalInfo";

export default function Index({ product, ingredients }) {
  const TabData = ({ product, ingredients }) => {
    const { weight, dimensions, attributes } = product;
    return (
      <>
        <Flex width="100%" mt="50px">
          <TabList aria-orientation="vertical" width="100%">
            <Tab
              fontSize="18px"
              fontWeight="400"
              fontFamily="Lato"
              _selected={{
                color: "maroon",
                borderBottomWidth: 3,
                borderBottomColor: "maroon",
              }}
            >
              Ingredients
            </Tab>
            <Tab
              fontSize="18px"
              fontWeight="400"
              fontFamily="Lato"
              _selected={{
                color: "maroon",
                borderBottomWidth: 3,
                borderBottomColor: "maroon",
              }}
            >
              Additional Information
            </Tab>
          </TabList>
        </Flex>
        <Flex width="100%">
          <TabPanels>
            <TabPanel>
              <ProductDescription ingredients={ingredients} />
            </TabPanel>
            <TabPanel>
              <ProductAdditionalInfo
                weight={weight}
                dimensions={dimensions}
                attributes={attributes}
              />
            </TabPanel>
          </TabPanels>
        </Flex>
      </>
    );
  };

  return (
    <>
      <Flex
        flexDirection="column"
        d={{ base: "none", lg: "flex" }}
        width={{ base: "90%", "2xl": "1350px" }}
      >
        <Tabs width="100%" height="fit-content">
          <TabData product={product} ingredients={ingredients} />
        </Tabs>
      </Flex>

      <Flex
        mt="50px"
        width="90%"
        display="block"
        flexDirection="column"
        d={{ base: "flex", lg: "none" }}
      >
        <Tabs
          width="100%"
          display="block"
          height="fit-content"
          orientation="vertical"
        >
          <TabData product={product} ingredients={ingredients} />
        </Tabs>
      </Flex>
    </>
  );
}
